module.exports = __webpack_public_path__ + "img/b1977b2fe72d7ea9576cc85cf3df30ee_clipart-rose-decoration_1567-2400.0a0b2498.png";